export default __webpack_public_path__ + "static/media/pets_logo.41ec79a4.png";